const eventNames = {
  viewer: {
    VIEWER_LOADED: '3D Viewer:Model Loaded',
    MODEL_INTERACTION: '3D Viewer:Model Interaction',
    WEBGL_CAPABILITIES: 'performance:webgl capabilities',
    DESIGN_FEATURE_ACTIVATED: '3D Viewer:Design Feature:Activated',
    DESIGN_FEATURE_DEACTIVATED: '3D Viewer:Design Feature:Deactivated',
    DESIGN_FEATURE_COLOR_SELECTION: '3D Viewer:Design Feature:Color Selection',
    DESIGN_FEATURE_PRODUCT_SELECTION:
      '3D Viewer:Design Feature:Product Selection',
    DESIGN_FEATURE_MANUFACTURER_SELECTION:
      '3D Viewer:Design Feature:Manufacturer Selection',
    DESIGN_FEATURE_PAINT_BRAND_SELECTION:
      '3D Viewer:Design Feature:Paint Brand Selection',
    DESIGN_FEATURE_PAINT_COLOR_SELECTION:
      '3D Viewer:Design Feature:Paint Color Selection',
    DESIGN_FEATURE_ADD_PAINT: '3D Viewer:Design Feature:Click:Paint Over',
    DESIGN_FEATURE_CLEAR_PAINT: '3D Viewer:Design Feature:Click:Clear Paint',
    DESIGN_FEATURE_CLICK_OVERRIDDEN_COLOR:
      '3D Viewer:Design Feature:Click:Overridden Color',
    DESIGN_FEATURE_CLICK_SAVE: '3D Viewer:Design Feature:Click:Save',
    DESIGN_FEATURE_CLICK_CANCEL_SAVE:
      '3D Viewer:Design Feature:Click:Cancel Save',
    DESIGN_FEATURE_CLICK_CONFIRM_SAVE:
      '3D Viewer:Design Feature:Click:Confirm Save',
    DESIGN_FEATURE_CLICK_REDO: '3D Viewer:Design Feature:Click:Redo',
    DESIGN_FEATURE_CLICK_UNDO: '3D Viewer:Design Feature:Click:Undo',
    DESIGN_FEATURE_CLICK_ZOOM_IN: '3D Viewer:Design Feature:Click:Zoom In',
    DESIGN_FEATURE_CLICK_ZOOM_OUT: '3D Viewer:Design Feature:Click:Zoom Out',
    DESIGN_FEATURE_MATERIAL_SELECTION:
      '3D Viewer:Design Feature:Material Selection',
    INITIAL_LOAD_TIME: '3D Viewer:Load:Timing:Initial Model Load Time',
    MEASUREMENTS_FEATURE_ACTIVATED: '3D Viewer:Measurements Feature:Activated',
    MEASUREMENTS_FEATURE_DEACTIVATED:
      '3D Viewer:Measurements Feature:Deactivated',
    share: {
      SHARE_FEATURE_CLICK: '3D Viewer:Share Feature:Click',
      SHARE_FEATURE_CLICK_COPY_LINK: '3D Viewer:Share Feature:Click Copy Link',
      SHARE_FEATURE_CLICK_SEND_EMAIL:
        '3D Viewer:Share Feature:Click Send Email',
      SHARE_FEATURE_CLICK_FACEBOOK: '3D Viewer:Share Feature:Click Facebook',
      SHARE_FEATURE_CLICK_TWITTER: '3D Viewer:Share Feature:Click Twitter',
    },
    FACADE_SPLIT_CONFIRMED: '3D Viewer:Design Feature:Click:Confirm Split',
    USER_NOT_AUTHENTICATED: '3d:background:authentication:error',
    CLICK_SCREENSHOT_MODE_FEATURE: '3d viewer:gallery:pressed',
    CLICK_EXIT_SCREENSHOT_MODE_FEATURE:
      '3d viewer:gallery screen:fullscreen gallery image:exit:pressed',
    CLICK_TAKE_SCREENSHOT: '3d viewer:gallery screen:generate image:pressed',
    CLICK_GALLERY_IMAGE:
      '3d viewer:gallery screen:fullscreen gallery image:appeared',
    CLICK_NAVIGATE_IN_LIGHTBOX_MODE:
      '3d viewer:gallery screen:fullscreen gallery image:arrow:pressed',
    DOWNLOAD_FROM_LIGHTBOX:
      '3d viewer:gallery screen:fullscreen image:download:pressed',
    BUTTON_PRESSED: 'Button Pressed',
    MODULE_VIEWED: 'Module Viewed',
    LINK_PRESSED: 'Link Pressed',
  },
};

export default eventNames;
